<template>
  <div class="circle-cards">
    <flickity
      class="slides"
      ref="flickity"
      :options="flickityOptions"
    >
      <CircleCard
        v-for="(slide, index) in slides"
        :key="index"
        v-bind="slide"
      />
    </flickity>
  </div>
</template>

<script>
import Flickity from 'vue-flickity'
import CircleCard from './CircleCard'
import { SuitIcon, QuestionsIcon, ConverterIcon, ScanIcon, FittingIcon } from './icons'

export default {
  name: 'CircleCards',
  data () {
    return {
      flickityOptions: {
        prevNextButtons: false,
        pageDots: true,
        wrapAround: true,
        dragThreshold: 10
      },
      slides: [{
        title: 'Een bolletjespak',
        icon: SuitIcon,
        description: 'Uit Japan kwam dit jaar een speciaal pak dat helpt je maat te meten. Een strakke legging, een shirt met lange mouwen en daarop 350 polkadots. Met het pak aan meet een app je exacte maten. Op basis daarvan kan je dan goed zittende kleding bestellen.'
      }, {
        title: 'Vragen over jouw lichaam',
        icon: QuestionsIcon,
        description: 'Dit doen sommige Nederlandse webshops al. Als je iets bestelt, krijg je vragen over onder meer je lengte, gewicht, buikomvang, heupen, bh-maat en leeftijd. Vervolgens krijg je een maat en een percentage met de kans dat die maat voor jou de juiste is.'
      }, {
        title: 'Converters',
        icon: ConverterIcon,
        description: 'Soms weet je van een bepaald merk precies welke maat jou past. Er bestaan al programma’s die de maten van verschillende merken naar elkaar omzetten.'
      }, {
        title: 'Met je smartphone je lichaam scannen',
        icon: ScanIcon,
        description: 'Verschillende apps proberen met de camera en sensoren van je smartphone je lichaamsverhoudingen te meten. Je neemt dan bijvoorbeeld een foto van voren en van de zijkant en de app bepaalt dan zo goed mogelijk je maten.'
      }, {
        title: 'Door een 3D-scanner',
        icon: FittingIcon,
        description: 'Uiteindelijk gaan we volgens experts toe naar een situatie waarin je een 3D-scan van je lichaam maakt. Je kan jezelf dan zelfs zien bewegen in bepaalde kleren om te kijken hoe het valt.'
      }]
    }
  },
  components: {
    Flickity,
    CircleCard
  }
}
</script>

<style lang="scss" scoped>
.circle-cards {
  position: relative;
  margin: 3em auto;
  width: 100%;
  max-width: 500px;
}

.slides {
  outline: 0;
}
</style>
<style lang="scss">
.circle-cards {
  .flickity-page-dots {
    position: static;
    bottom: 0;
    margin-top: 31px;
    font-size: 0;

    .dot {
      background-color: rgba(0, 0, 0, 0.2);
      opacity: 1;
      width: 13px;
      height: 13px;
      margin: 0 5px;
      will-change: opacity;
      transition: opacity 200ms ease;
      position: relative;

      &:hover {
        opacity: 0.8;
      }

      &::after {
        content: '';
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: $c-pink;
        transform: scale(0);
        z-index: 1;
        transition: transform 400ms ease;
        will-change: transform;
        border-radius: 50%;
      }

      &.is-selected::after {
        transform: scale(1);
      }
    }
  }
}
</style>
